module.exports = __webpack_public_path__ + "media/images/home-icon-1ca58222f3dae86e414ad9a405ef2df3.png";